import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const input = this.element;
        const resetButton = this.element.querySelector('.button-reset');

        this.initCustomFileInput(input);

        if (resetButton) {
            resetButton.addEventListener('click', ()=>{
                this.resetFileInput(this.element);
            });
        }
    }

    initCustomFileInput(el) {
        const fileInput = el.querySelector('[type="file"]');
        const defaultLabel = el.querySelector('.label-default');
        const resetButton = el.querySelector('.button-reset');
        const label = el.querySelector('.label');

        fileInput.onchange = function () {
                if (!fileInput.value) return;

                const value = fileInput.value.replace(/^.*[\\/]/, '');
                if (!el.classList.contains('chosen')) {
                    el.classList.add('chosen');
                }

                if (!defaultLabel.classList.contains('d-none')) {
                    defaultLabel.classList.add('d-none');
                }

                if (!label.classList.contains('d-block')) {
                    label.classList.add('d-block');
                }

                if (!resetButton.classList.contains('d-block')) {
                    resetButton.classList.add('d-block');
                }
                label.innerText = value;
            };
    }

    resetFileInput(el) {
        const fileInput = el.querySelector('[type="file"]');
        const label = el.querySelector('.label');
        const defaultLabel = el.querySelector('.label-default');
        const resetButton = el.querySelector('.button-reset');

        if (fileInput) {
            fileInput.value = null;
        }

        if (resetButton.classList.contains('d-block')) {
            resetButton.classList.remove('d-block');
        }

        if (label && defaultLabel) {
            label.classList.remove('d-block');
            defaultLabel.classList.remove('d-none');
        }
    }
}